import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class DispensingEventVm {
	dispenseDate: Date;
	dispenseDateLocal: Date;
	strDispenseDateTime?: string;
	client?: string;
	site?: string;
	tankAssetNumber?: string;
	gallons?: number;
	personnel?: string;
	driverId?: number;
	emergencyEvent?: string;
	barcodeId: number;
	id: number;
	barcodeString?: string;
	tagNumber?: string;
	clientId?: number;
	unitId?: number;
	unit?: string;
	emergencyEventId?: number;
	assetId?: number;
	asset?: string;
	assetIds?: number[];
	assets?: string[];
	siteLocationId?: number;
	siteLocationName?: string;
	isUpdatedOffline: boolean;
	offlineBarcodeId?: any;
	fuelType?: string;
	fuelTypeId: number;
	secondaryFuelType?: string;
	secondaryFuelTypeId?: number;
	secondaryGallons?: number;
	latitude?: number;
	longitude?: number;
	coordinates?: string;
	notes?: string;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'dispenseDate': new UntypedFormControl('', [...(validators['dispenseDate'] ?? []), ...[Validators.required]]),
			'dispenseDateLocal': new UntypedFormControl('', [...(validators['dispenseDateLocal'] ?? []), ...[Validators.required]]),
			'strDispenseDateTime': new UntypedFormControl(null, [...(validators['strDispenseDateTime'] ?? []), ...[]]),
			'client': new UntypedFormControl(null, [...(validators['client'] ?? []), ...[]]),
			'site': new UntypedFormControl(null, [...(validators['site'] ?? []), ...[]]),
			'tankAssetNumber': new UntypedFormControl(null, [...(validators['tankAssetNumber'] ?? []), ...[]]),
			'gallons': new UntypedFormControl(null, [...(validators['gallons'] ?? []), ...[Validators.required, Validators.min(0.001), Validators.max(100000)]]),
			'personnel': new UntypedFormControl(null, [...(validators['personnel'] ?? []), ...[]]),
			'driverId': new UntypedFormControl(null, [...(validators['driverId'] ?? []), ...[]]),
			'emergencyEvent': new UntypedFormControl(null, [...(validators['emergencyEvent'] ?? []), ...[]]),
			'barcodeId': new UntypedFormControl(0, [...(validators['barcodeId'] ?? []), ...[Validators.required]]),
			'id': new UntypedFormControl(0, [...(validators['id'] ?? []), ...[Validators.required]]),
			'barcodeString': new UntypedFormControl(null, [...(validators['barcodeString'] ?? []), ...[Validators.maxLength(50)]]),
			'tagNumber': new UntypedFormControl(null, [...(validators['tagNumber'] ?? []), ...[Validators.maxLength(50)]]),
			'clientId': new UntypedFormControl(null, [...(validators['clientId'] ?? []), ...[Validators.required]]),
			'unitId': new UntypedFormControl(null, [...(validators['unitId'] ?? []), ...[Validators.required]]),
			'unit': new UntypedFormControl(null, [...(validators['unit'] ?? []), ...[]]),
			'emergencyEventId': new UntypedFormControl(null, [...(validators['emergencyEventId'] ?? []), ...[Validators.required]]),
			'assetId': new UntypedFormControl(null, [...(validators['assetId'] ?? []), ...[Validators.required]]),
			'asset': new UntypedFormControl(null, [...(validators['asset'] ?? []), ...[]]),
			'assetIds': new UntypedFormControl([], [...(validators['assetIds'] ?? []), ...[]]),
			'assets': new UntypedFormControl([], [...(validators['assets'] ?? []), ...[]]),
			'siteLocationId': new UntypedFormControl(null, [...(validators['siteLocationId'] ?? []), ...[Validators.required]]),
			'siteLocationName': new UntypedFormControl(null, [...(validators['siteLocationName'] ?? []), ...[]]),
			'isUpdatedOffline': new UntypedFormControl(false, [...(validators['isUpdatedOffline'] ?? []), ...[]]),
			'offlineBarcodeId': new UntypedFormControl(null, [...(validators['offlineBarcodeId'] ?? []), ...[]]),
			'fuelType': new UntypedFormControl(null, [...(validators['fuelType'] ?? []), ...[]]),
			'fuelTypeId': new UntypedFormControl(0, [...(validators['fuelTypeId'] ?? []), ...[Validators.required]]),
			'secondaryFuelType': new UntypedFormControl(null, [...(validators['secondaryFuelType'] ?? []), ...[]]),
			'secondaryFuelTypeId': new UntypedFormControl(null, [...(validators['secondaryFuelTypeId'] ?? []), ...[]]),
			'secondaryGallons': new UntypedFormControl(null, [...(validators['secondaryGallons'] ?? []), ...[Validators.min(0.001), Validators.max(100000)]]),
			'latitude': new UntypedFormControl(null, [...(validators['latitude'] ?? []), ...[]]),
			'longitude': new UntypedFormControl(null, [...(validators['longitude'] ?? []), ...[]]),
			'coordinates': new UntypedFormControl(null, [...(validators['coordinates'] ?? []), ...[]]),
			'notes': new UntypedFormControl(null, [...(validators['notes'] ?? []), ...[Validators.maxLength(500)]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static get ColumnDefs(): Map<string, PcgTableColumn> {
		return new Map([
			['dispenseDateLocal', {"orderId":0,"sortColumn":"strDispenseDateTime","searchColumn":"dispenseDateLocal","includeInExcel":true,"exportColumn":null,"displayName":"Dispense Date","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['client', {"orderId":1,"sortColumn":"client","searchColumn":"client","includeInExcel":true,"exportColumn":null,"displayName":"Client","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['site', {"orderId":2,"sortColumn":"site","searchColumn":"site","includeInExcel":true,"exportColumn":null,"displayName":"Site","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['tankAssetNumber', {"orderId":3,"sortColumn":"tankAssetNumber","searchColumn":"tankAssetNumber","includeInExcel":true,"exportColumn":null,"displayName":"Tank Asset #","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['emergencyEvent', {"orderId":4,"sortColumn":"emergencyEvent","searchColumn":"emergencyEvent","includeInExcel":true,"exportColumn":null,"displayName":"Emergency Event","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['personnel', {"orderId":5,"sortColumn":"personnel","searchColumn":"personnel","includeInExcel":true,"exportColumn":null,"displayName":"Personnel","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['coordinates', {"orderId":6,"sortColumn":"coordinates","searchColumn":"coordinates","includeInExcel":true,"exportColumn":null,"displayName":"Coordinates","isVisible":true,"canSearch":false,"multiSearchCellClasses":null}],
			['gallons', {"orderId":7,"sortColumn":"gallons","searchColumn":"gallons","includeInExcel":true,"exportColumn":null,"displayName":"Gallons/Units Pumped","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['fuelType', {"orderId":8,"sortColumn":"fuelType","searchColumn":"fuelType","includeInExcel":true,"exportColumn":null,"displayName":"Fuel Type","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['secondaryFuelType', {"orderId":9,"sortColumn":"secondaryFuelType","searchColumn":"secondaryFuelType","includeInExcel":true,"exportColumn":null,"displayName":"Secondary Fuel Type","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['secondaryGallons', {"orderId":10,"sortColumn":"secondaryGallons","searchColumn":"secondaryGallons","includeInExcel":true,"exportColumn":null,"displayName":"Gallons Pumped (Secondary Fuel)","isVisible":true,"canSearch":true,"multiSearchCellClasses":null}],
			['notes', {"orderId":11,"sortColumn":"notes","searchColumn":"notes","includeInExcel":true,"exportColumn":null,"displayName":"Notes","isVisible":false,"canSearch":true,"multiSearchCellClasses":null}],
			['delete', {"orderId":12,"sortColumn":"delete","searchColumn":"delete","includeInExcel":false,"exportColumn":null,"displayName":"Delete","isVisible":true,"canSearch":false,"multiSearchCellClasses":null}]
		]);
	}

	static GetModel(fg: UntypedFormGroup): DispensingEventVmFromFg {
		return new DispensingEventVmFromFg(fg);
	}
}

export class DispensingEventVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get dispenseDate(): Date {
		return this.fg.get('dispenseDate').value;
	}
	set dispenseDate(val) {
		this.fg.get('dispenseDate').setValue(val);
	}

	get dispenseDateLocal(): Date {
		return this.fg.get('dispenseDateLocal').value;
	}
	set dispenseDateLocal(val) {
		this.fg.get('dispenseDateLocal').setValue(val);
	}

	get strDispenseDateTime(): string {
		return this.fg.get('strDispenseDateTime').value;
	}
	set strDispenseDateTime(val) {
		this.fg.get('strDispenseDateTime').setValue(val);
	}

	get client(): string {
		return this.fg.get('client').value;
	}
	set client(val) {
		this.fg.get('client').setValue(val);
	}

	get site(): string {
		return this.fg.get('site').value;
	}
	set site(val) {
		this.fg.get('site').setValue(val);
	}

	get tankAssetNumber(): string {
		return this.fg.get('tankAssetNumber').value;
	}
	set tankAssetNumber(val) {
		this.fg.get('tankAssetNumber').setValue(val);
	}

	get gallons(): number {
		return this.fg.get('gallons').value;
	}
	set gallons(val) {
		this.fg.get('gallons').setValue(val);
	}

	get personnel(): string {
		return this.fg.get('personnel').value;
	}
	set personnel(val) {
		this.fg.get('personnel').setValue(val);
	}

	get driverId(): number {
		return this.fg.get('driverId').value;
	}
	set driverId(val) {
		this.fg.get('driverId').setValue(val);
	}

	get emergencyEvent(): string {
		return this.fg.get('emergencyEvent').value;
	}
	set emergencyEvent(val) {
		this.fg.get('emergencyEvent').setValue(val);
	}

	get barcodeId(): number {
		return this.fg.get('barcodeId').value;
	}
	set barcodeId(val) {
		this.fg.get('barcodeId').setValue(val);
	}

	get id(): number {
		return this.fg.get('id').value;
	}
	set id(val) {
		this.fg.get('id').setValue(val);
	}

	get barcodeString(): string {
		return this.fg.get('barcodeString').value;
	}
	set barcodeString(val) {
		this.fg.get('barcodeString').setValue(val);
	}

	get tagNumber(): string {
		return this.fg.get('tagNumber').value;
	}
	set tagNumber(val) {
		this.fg.get('tagNumber').setValue(val);
	}

	get clientId(): number {
		return this.fg.get('clientId').value;
	}
	set clientId(val) {
		this.fg.get('clientId').setValue(val);
	}

	get unitId(): number {
		return this.fg.get('unitId').value;
	}
	set unitId(val) {
		this.fg.get('unitId').setValue(val);
	}

	get unit(): string {
		return this.fg.get('unit').value;
	}
	set unit(val) {
		this.fg.get('unit').setValue(val);
	}

	get emergencyEventId(): number {
		return this.fg.get('emergencyEventId').value;
	}
	set emergencyEventId(val) {
		this.fg.get('emergencyEventId').setValue(val);
	}

	get assetId(): number {
		return this.fg.get('assetId').value;
	}
	set assetId(val) {
		this.fg.get('assetId').setValue(val);
	}

	get asset(): string {
		return this.fg.get('asset').value;
	}
	set asset(val) {
		this.fg.get('asset').setValue(val);
	}

	get siteLocationId(): number {
		return this.fg.get('siteLocationId').value;
	}
	set siteLocationId(val) {
		this.fg.get('siteLocationId').setValue(val);
	}

	get siteLocationName(): string {
		return this.fg.get('siteLocationName').value;
	}
	set siteLocationName(val) {
		this.fg.get('siteLocationName').setValue(val);
	}

	get isUpdatedOffline(): boolean {
		return this.fg.get('isUpdatedOffline').value;
	}
	set isUpdatedOffline(val) {
		this.fg.get('isUpdatedOffline').setValue(val);
	}

	get offlineBarcodeId(): any {
		return this.fg.get('offlineBarcodeId').value;
	}
	set offlineBarcodeId(val) {
		this.fg.get('offlineBarcodeId').setValue(val);
	}

	get fuelType(): string {
		return this.fg.get('fuelType').value;
	}
	set fuelType(val) {
		this.fg.get('fuelType').setValue(val);
	}

	get fuelTypeId(): number {
		return this.fg.get('fuelTypeId').value;
	}
	set fuelTypeId(val) {
		this.fg.get('fuelTypeId').setValue(val);
	}

	get secondaryFuelType(): string {
		return this.fg.get('secondaryFuelType').value;
	}
	set secondaryFuelType(val) {
		this.fg.get('secondaryFuelType').setValue(val);
	}

	get secondaryFuelTypeId(): number {
		return this.fg.get('secondaryFuelTypeId').value;
	}
	set secondaryFuelTypeId(val) {
		this.fg.get('secondaryFuelTypeId').setValue(val);
	}

	get secondaryGallons(): number {
		return this.fg.get('secondaryGallons').value;
	}
	set secondaryGallons(val) {
		this.fg.get('secondaryGallons').setValue(val);
	}

	get latitude(): number {
		return this.fg.get('latitude').value;
	}
	set latitude(val) {
		this.fg.get('latitude').setValue(val);
	}

	get longitude(): number {
		return this.fg.get('longitude').value;
	}
	set longitude(val) {
		this.fg.get('longitude').setValue(val);
	}

	get coordinates(): string {
		return this.fg.get('coordinates').value;
	}
	set coordinates(val) {
		this.fg.get('coordinates').setValue(val);
	}

	get notes(): string {
		return this.fg.get('notes').value;
	}
	set notes(val) {
		this.fg.get('notes').setValue(val);
	}
}
